//
//
//
//
//
//

export default {
  props: {
    caption: String
  }
}
